import React from 'react';

import { StyledHelpBox, StyledExpressionCode } from './ExpressionHelp.styled';

const ExpressionHelp = () => (
  <StyledHelpBox>
    Expressions use Scriban syntax. Reference step outputs with{' '}
    <StyledExpressionCode>{'{{ stepId.outputName }}'}</StyledExpressionCode>, job inputs with{' '}
    <StyledExpressionCode>{'{{ input.fieldName }}'}</StyledExpressionCode>.
  </StyledHelpBox>
);

const MemoExpressionHelp = React.memo(ExpressionHelp);

export { MemoExpressionHelp as ExpressionHelp };
export default MemoExpressionHelp;
